import React, { Component } from "react";

import { states } from "../../../reducers/queriesStates";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Preloader from "../../../shared/items/static/preloader";
import styles from "./cmsUnitChangePanel.module.scss";

class CmsTransferUnitsTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      transferToCompanyId: null,
      transferToCompanyFail: false,
      transfered: false,
    };
  }

  componentDidMount() {
    const { onGetCompanies, ownershipAreasDataState } = this.props;

    if (ownershipAreasDataState !== states.READY) {
      onGetCompanies({ count: -1 });
    } else {
      this.setCompanies();
    }
  }

  componentDidUpdate(prevProps) {
    const { ownershipAreasDataState, transferUnitToCompanyDataState } = this.props;

    if (ownershipAreasDataState === states.READY && prevProps.ownershipAreasDataState === states.REQUEST) {
      this.setCompanies();
    }

    if (transferUnitToCompanyDataState === states.FAILURE && prevProps.transferUnitToCompanyDataState === states.REQUEST) {
      this.setState({ transferToCompanyFail: true, transfered: false });

      setTimeout(() => {
        this.setState({ transferToCompanyFail: false });
      }, 3000);
    }
  }

  setCompanies() {
    const { ownershipAreas, company } = this.props;

    let companies = [];

    ownershipAreas.ownershipAreas.forEach((area) => {
      const areaCompanies = area.companies.filter((item) => {
        return company.id !== item.id;
      });

      if (areaCompanies.length > 0) {
        companies = companies.concat(areaCompanies);
      }
    });

    companies = companies.sort((a, b) => {
      const nameA = a.title.toUpperCase();
      const nameB = b.title.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });

    this.setState({ companies });
  }

  handleClick() {
    const { onTransferUnitsToCompany, selectUnits } = this.props;
    const { transferToCompanyId } = this.state;

    if (transferToCompanyId) {
      this.setState({ transfered: true });
      onTransferUnitsToCompany(transferToCompanyId, selectUnits);
    }
  }

  onSelectCompany(e) {
    this.setState({ transferToCompanyId: e.target.value });
  }

  render() {
    const { companies, transferToCompanyFail, transfered } = this.state;
    const { selectUnits } = this.props;

    if (selectUnits.length === 0) {
      return null;
    }

    return (
      <FormControl variant="standard" sx={{ m: 1, minWidth: 250, display: "inline-block" }}>
        <div style={{ display: "flex" }}>
          <Select
            style={{ minWidth: "700px" }}
            onChange={this.onSelectCompany.bind(this)}
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
          >
            <MenuItem value={null} className={styles.MuiButtonBase_resolve}>
              {"- - - "}
            </MenuItem>
            {companies.map((area) => {
              return (
                <MenuItem key={area.id} value={area.id} className={styles.MuiButtonBase_resolve}>
                  {area.title}
                </MenuItem>
              );
            })}
          </Select>
          <div style={{ paddingLeft: "15px" }}>
            {transfered ? <Preloader /> : <ButtonPrimary handleClick={this.handleClick.bind(this)} title="Перенести в компанию" />}
          </div>
        </div>
        <div style={{ color: "red", fontWeight: 900, fontSize: "14px" }}>{transferToCompanyFail ? "Ошибка переноса транспорта" : null}</div>
      </FormControl>
    );
  }
}

export default withCompanies(CmsTransferUnitsTools);
